<template>
  <div class="text-center">
    <div class="mb-3">
      <i :class="emptyInfo.icon" class="text-primary fs-70"></i>
    </div>
    <div class="text-body fs-20">{{ emptyInfo.title }}</div>
    <div class="text-muted fs-14">{{ emptyInfo.description }}</div>
  </div>
</template>
<script>
export default {
  props: {
    emptyInfo: {
      type: Object,
      default: () => {
        return {
          title: "暂未创建产品",
          description: "您可点击右上角按钮新建产品",
          icon: "bx bxs-error-circle",
        };
      },
    },
  },
};
</script>
